import styled from 'styled-components'

export const Container = styled.div`
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: -10px;
`

export const Slider = styled.div`
  position: relative;
  width: 250px;
`

export const SliderTrack = styled.div`
  position: absolute;
  border-radius: 3px;
  height: 5px;
  background-color: #ced4da;
  width: 100%;
  z-index: 1;
`

export const SliderRange = styled.div`
  position: absolute;
  border-radius: 3px;
  height: 5px;
  background-color: black;
  z-index: 2;
`

export const SliderValue = styled.div`
  position: absolute;
  font-size: 12px;
  margin-top: 20px;
`

export const Thumb = styled.input.attrs({ type: 'range', step: 1 })`
  -webkit-appearance: none;
  -webkit-tap-highlight-color: transparent;
  pointer-events: none;
  position: absolute;
  height: 0;
  width: 250px;
  outline: none;
  z-index: 4;

  &::-webkit-slider-thumb {
    background: #f1f5f7;
    -webkit-appearance: none;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ced4da;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }

  &::-moz-range-thumb {
    background-color: #white;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px #ced4da;
    cursor: pointer;
    height: 18px;
    width: 18px;
    margin-top: 4px;
    pointer-events: all;
    position: relative;
  }
}
`
